import { http } from "../config/http"

export const login = async (email_id: string, password: string) => {
    try {
        const response = await http.post(`user_login`, {
            email_id: email_id, 
            password: password,
        })
        return { result: response?.data }
    } catch (error) {
        const message = error instanceof Error ? error.message : "Unknown error";
        return {
            error: message
        }
    }

};

export const signUp = async (username: string, password: string, first_name: string, last_name: string) => {
    try {
        const res = await http.post('user_signup', {
            email_id: username,
            first_name: first_name,
            last_name: last_name,
            password: password,
        })
        return { result: res?.data }
    } catch (error: unknown) {
        const message = error instanceof Error ? error.message : "Unknown error";
        return {
            error: message
        }
    }
}